import { useMutation } from "@tanstack/react-query"
import * as queries from '@supabase/queries';
import {useUserStore} from "../../zustand/useStore";
import ErrorPopup from "@/components/custom/InfoPopups/ErrorPopup";
interface User {
    email: string;
    password: string;
}



export default function useSignIn(onSuccessCallback?: () => void) {
    const login = useUserStore(state => state.login)

    return useMutation({
        mutationFn: async (user: User) => {
            const { data: login_data, error: login_error } = await queries.signIn(user.email, user.password);
            if (login_error) {
                throw login_error
            }
            const { data: user_data, error: user_error } = await queries.getUserData(login_data?.user?.id);
          
            if (user_error) {
                throw user_error
            }
            const { first_name, last_name, id, email } = user_data[0];
            const { session } = login_data;
            const user_final = {
                first_name, 
                last_name, 
                id,
                email, 
                session
            }
            login(user_final);
            return user_final
        },
        onError: (error: Error) => {
            ErrorPopup(error.message, 5000);
        },
        onSuccess: () => {
            onSuccessCallback && onSuccessCallback();
        }
    });

    // return useMutation(async (user: User) => {
    //     console.log("[useSignIn] invoked!");
    //     const { data: login_data, error: login_error } = await queries.signIn(user.email, user.password);
    //     if (login_error) {
    //         throw login_error
    //     }
    //     const { data: user_data, error: user_error } = await queries.getUserData(login_data?.user?.id);
    //     console.log(user_data)
    //     if (user_error) {
    //         throw user_error
    //     }
    //     const { first_name, last_name, id } = user_data[0];
    //     const { session } = login_data;
    //     const user_final = {
    //         first_name, last_name, id,
    //         session
    //     }
    //     login(user_final);
    //     return user_final
    // },
    //     {
    //         onSuccess: () => {
    //             onSuccessCallback && onSuccessCallback();
    //         },
    //         onError: (error: Error) => {
    //             ErrorPopup(error.message, 5000);
    //         }
    //     }
    // )
}